import RRule from 'rrule';

export const repeatOptions = [
  { label: 'Once', value: -1 },
  { label: 'Daily', value: RRule.DAILY },
  { label: 'Every Other Day', value: 11 },
  { label: 'Weekly', value: RRule.WEEKLY },
  { label: 'Monthly', value: RRule.MONTHLY },
  { label: 'Custom', value: 10 },
];

export const repeatEveryOptions = [
  { label: 'Day(s)', value: RRule.DAILY },
  { label: 'Week(s)', value: RRule.WEEKLY },
  { label: 'Month(s)', value: RRule.MONTHLY },
];

export const endsOptions = [
  { label: 'On', value: 'on' },
  { label: 'After', value: 'after' },
];
